import React, { useState, useContext, useEffect } from "react";
import { StyleSheet, TouchableOpacity, Text } from "react-native";
import { Button, Avatar } from "react-native-paper";
import { View } from "../shared/Themed";
import AvatarMenu from "./AvatarMenu";
import { useDispatch, useSelector } from "react-redux";
import DeviceOrientationContext from "../context/DeviceOrientationContext";
import { ConfigurationDispatcher } from "../../redux/dispatcher/configurationDispatcher";
import { actionTypesConfigurations } from "../../redux/constants/actionTypesConfigurations";
import { getAllNotificationsCount } from "../../redux/dispatcher/notificationDispatcher";

export default function UserAvatar() {
  const [isVisible] = useState<boolean>(false);
  const { loading, notificationCount } = useSelector(
    (state: any) => state.notification
  );
  const dispatch = useDispatch<any>();
  const orientationContext = useContext(DeviceOrientationContext);
  // Redux state selection
  const { userInfo, hasAvatarMenu, hasAvatar, isDrawer, profilePhoto }: any =
    useSelector((state: any) => state.configurations);
  const setHasAvatarMenu = (data: boolean) => {
    ConfigurationDispatcher(actionTypesConfigurations.HasAvatarMenu, data);
  };

  const fullName: string[] = userInfo?.display_name?.split(" ") ?? [];
  const initial = fullName.length > 0 ? fullName[0].charAt(0) : "U";

  useEffect(() => {
    dispatch(getAllNotificationsCount());
  }, []);

  return (
    <View
      style={[
        styles.container,
        {
          marginLeft: orientationContext.isSmallDevice
            ? "85%"
            : orientationContext?.isMediumDevice
            ? "95%"
            : "97%",
        },
      ]}
    >
      <View style={styles.avatar}>
        <TouchableOpacity
          style={{ flexDirection: "row" }}
          onPress={() => setHasAvatarMenu(!hasAvatarMenu)}
        >
          <View style={styles.avatarWrapper}>
            {hasAvatar ? (
              <Avatar.Image
                size={isDrawer ? 55 : 35}
                source={profilePhoto}
                style={{ backgroundColor: "white" }}
              />
            ) : (
              <Avatar.Text
                size={isDrawer ? 55 : 35}
                label={initial}
                style={{ backgroundColor: "#3d4db7" }}
              />
            )}
            {!loading && notificationCount > 0 && (
              <View style={styles.badge}>
                <Text style={styles.badgeText}>{notificationCount}</Text>
              </View>
            )}
          </View>

          {!orientationContext.isSmallDevice && (
            <Button
              style={styles.icon}
              contentStyle={{ width: 50 }}
              color="grey"
              icon={isVisible ? "menu-up" : "menu-down"}
              onPress={() => setHasAvatarMenu(!hasAvatarMenu)}
            />
          )}
        </TouchableOpacity>

        {hasAvatarMenu && !isDrawer && !orientationContext.isSmallDevice ? (
          <View
            style={[
              styles.avatarMenu,
              styles.shadowProp,
              {
                width: orientationContext.isSmallDevice ? 200 : 300,
                right: orientationContext.isSmallDevice ? 40 : 10,
              },
            ]}
          >
            <AvatarMenu />
          </View>
        ) : (
          <View />
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  avatar: {
    justifyContent: "space-around",
  },
  container: {
    position: "absolute",
    width: "10%",
    height: 30,
    flexDirection: "row",
    marginTop: 15,
  },
  avatarWrapper: {
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
  },
  badge: {
    position: "absolute",
    top: -4,
    right: -4,
    backgroundColor: "red",
    borderRadius: 10,
    paddingHorizontal: 5,
    minWidth: 18,
    height: 18,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  badgeText: {
    color: "white",
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
  },
  avatarMenu: {
    textAlign: "left",
    position: "absolute",
    borderWidth: 1,
    borderColor: "lightgrey",
    borderRadius: 8,
    backgroundColor: "white",
    marginTop: 380,
    zIndex: 1,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 3,
  },
  icon: {
    marginTop: 14,
  },
});
